<template>
    <b-form :save-url="addUrl" @success="formSuccess" v-slot="{model, loading}"
            :initial-data="initialData">

        <div class="row">
            <div class="col-6">
                <validated-input label="Title*" v-model="model.title"
                                 :rules="{required: true, max:20}" :disabled="loading"/>
            </div>
            <div class="col-6">
                <validated-input label="Order" type="number" v-model="model.order"
                                 :rules="{required: false, min_value:1}" :disabled="loading"/>
            </div>

            <div class="col-12">
                <validated-text-area label="Description*" v-model="model.description"
                                    :rules="{required: true, max:110}" :disabled="loading"/>
            </div>
            <div class="col-12">
                <validated-checkbox label="Enabled" v-model="model.is_enabled"
                                :rules="{required: false}" :disabled="loading"/>
            </div>
            <div class="col-12 text-right">
                <btn class="trn" size="sm" :loading="loading" color="primary" text="Update"
                     loading-text="Updating..." :disabled="loading"/>
            </div>
        </div>

    </b-form>
</template>

<script>
import urls from '@/data/cms-urls';

export default {
    name : 'EditHowItWorks',

    props : { initialData : { type : Object } },

    data () {
        return {
            addUrl : urls.cms.howItWorks.addEdit
        };
    },

    methods : {
        formSuccess () {
            this.$notify('Successfully Edited How It Works..!', 'Success',
                {
                    type : 'success'
                }
            );
            this.$emit('success');
        }
    }
};
</script>

<style scoped>

</style>
